import CustomInput from "./CustomInput";

const SERVICE_GRID = "grid-cols-[2fr_2fr_1.5fr_40px]";

const ServicePriceTierEditor = ({ tiers = [], onChange }) => {
  const updateTier = (index, field, value) => {
    let next = [...tiers];

    next[index] = { ...next[index], [field]: value };

    if (field === "maxQty") {
      for (let i = index + 1; i < next.length; i++) {
        if (next[i - 1].maxQty == null) break;
        next[i].minQty = next[i - 1].maxQty + 1;
      }
    }

    onChange(next);
  };

  const removeTier = (index) => {
    if (index === 0) return;
    const next = tiers.filter((_, i) => i !== index);

    for (let i = 1; i < next.length; i++) {
      if (next[i - 1].maxQty == null) break;
      next[i].minQty = next[i - 1].maxQty + 1;
    }

    onChange(next);
  };

  const addTier = () => {
    const last = tiers[tiers.length - 1];
    if (last?.maxQty == null) return;

    onChange([
      ...tiers,
      {
        rangeName: "",
        minQty: last.maxQty + 1,
        maxQty: null,
        price: 0,
      },
    ]);
  };

  const lastTierIsInfinity =
    tiers.length > 0 && tiers[tiers.length - 1].maxQty == null;

  return (
    <div className="border rounded-xl overflow-hidden bg-white">
      <div
        className={`grid ${SERVICE_GRID} px-4 py-3 text-sm font-semibold text-gray-600 border-b bg-gray-50 gap-4`}
      >
        <div>Tên khoảng</div>
        <div>Số lượng</div>
        <div>Đơn giá</div>
        <div />
      </div>

      {tiers.map((tier, index) => {
        const isLast = tier.maxQty == null;
        const isSingle = tier.minQty === tier.maxQty;

        return (
          <div
            key={index}
            className={`grid ${SERVICE_GRID} px-4 py-3 items-center text-sm border-t gap-4 ${isLast ? "bg-blue-50/50" : "bg-white"
              }`}
          >
            <CustomInput
              value={tier.rangeName || ""}
              placeholder="Nhập tên khoảng..."
              onChange={(v) => updateTier(index, "rangeName", v)}
              height="36px"
            />

            <div className="flex items-center gap-2">
              <div className="w-[100px]">
                <CustomInput
                  type="number"
                  value={tier.minQty}
                  disabled
                  height="36px"
                />
              </div>

              {!isSingle && (
                <>
                  <span className="text-gray-400">–</span>

                  <div className="w-[100px]">
                    <CustomInput
                      type="number"
                      value={tier.maxQty ?? ""}
                      placeholder="∞"
                      onChange={(v) =>
                        updateTier(index, "maxQty", v === "" ? null : Number(v))
                      }
                      height="36px"
                    />
                  </div>
                </>
              )}

              {/* {isLast && (
                <span className="ml-2 text-xs text-blue-600 font-medium">
                  trở lên
                </span>
              )} */}
            </div>

            <CustomInput
              type="number"
              value={tier.price}
              onChange={(v) => updateTier(index, "price", Number(v) || 0)}
              height="36px"
            />

            <div className="flex justify-end">
              {index > 0 && (
                <button
                  onClick={() => removeTier(index)}
                  className="text-gray-400 hover:text-red-500 text-lg leading-none"
                  title="Xóa mức giá"
                >
                  ×
                </button>
              )}
            </div>
          </div>
        );
      })}

      {!lastTierIsInfinity && (
        <div className="px-4 py-3 border-t bg-gray-50">
          <button
            onClick={addTier}
            className="text-blue-600 text-sm font-medium hover:underline"
          >
            + Thêm mức giá
          </button>
        </div>
      )}
    </div>
  );
};

export default ServicePriceTierEditor;
